import CardRankings from "../../../../src/components/card-rankings/CardRankings";
import tdcRatings from "../../../../src/data/articles/cube-prospective-tarkir-dragonstorm-commander/tdc-prospective-ratings.json";
import ProspectiveIntro from "../../../../src/components/article-elements/ProspectiveIntro.tsx";
import * as React from 'react';
export default {
  CardRankings,
  tdcRatings,
  ProspectiveIntro,
  React
};